// @flow

import React from 'react';

import {
  Button,
  ButtonGroup,
  Hoverable,
  Popover,
} from '@zapier/common-components';

import type { ChangeType } from '@zapier/common-utils';

type ChangePlanButtonsProps = {
  changeType: ChangeType,
  fromPlanName: string,
  isDisabled: boolean,
  onCancelChangePlan: (
    fromPlanName: string,
    planName: string,
    selectedBillingInterval: string,
    changeType: ChangeType
  ) => void,
  onChangePlan: (
    fromPlanName: string,
    planName: string,
    selectedBillingInterval: string,
    changeType: ChangeType
  ) => void,
  planName: string,
  selectedBillingInterval: string,
  submitText: string,
};

const ChangePlanButtons = ({
  changeType,
  fromPlanName,
  isDisabled,
  onCancelChangePlan,
  onChangePlan,
  planName,
  selectedBillingInterval,
  submitText,
}: ChangePlanButtonsProps) => {
  const handleOnChangePlan = () =>
    onChangePlan(fromPlanName, planName, selectedBillingInterval, changeType);

  const handleOnCancelChangePlan = () =>
    onCancelChangePlan(
      fromPlanName,
      planName,
      selectedBillingInterval,
      changeType
    );

  return (
    <ButtonGroup
      propsQueries={{
        tabletPortraitPlus: {
          direction: 'row',
          isReversed: true,
          justify: 'flex-start',
        },
      }}
    >
      <Hoverable>
        {({ isHovered }) => (
          <Popover
            content={'Please add a payment method.'}
            isCompact={true}
            noWrap={true}
            role="tooltip"
            show={isDisabled && isHovered}
            theme="dark"
          >
            <Button
              color="primary"
              isDisabled={isDisabled}
              isFullWidth={true}
              label="change plan"
              onClick={handleOnChangePlan}
            >
              {submitText}
            </Button>
          </Popover>
        )}
      </Hoverable>
      <Button
        backgroundType="clear"
        color="secondary"
        label="cancel change plan"
        onClick={handleOnCancelChangePlan}
        type="button"
      >
        Cancel
      </Button>
    </ButtonGroup>
  );
};

export default ChangePlanButtons;
